import { render, staticRenderFns } from "./SessionCard.vue?vue&type=template&id=fee530c0&scoped=true"
import script from "./SessionCard.vue?vue&type=script&lang=ts"
export * from "./SessionCard.vue?vue&type=script&lang=ts"
import style0 from "./SessionCard.vue?vue&type=style&index=0&id=fee530c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee530c0",
  null
  
)

export default component.exports